export default "__VITE_ASSET__bc1c5090__"